import { IamAccount } from '@/apis/iam-accounts-api';
import * as iamAccountsApi from '@/apis/iam-accounts-api';
import { InvalidSchemaException } from '@/models';

/**
 * Get the IAM account of the user
 * @param accountId The account ID
 * @param accessToken The access token for authentication
 */
export const getAccount = async (accountId: string, accessToken: string): Promise<IamAccount> => {
  const response = await iamAccountsApi.getAccount(accountId, accessToken);

  if (!isIamAccount(response)) {
    throw new InvalidSchemaException('Invalid schema');
  }

  return response as IamAccount;
};

/**
 * Check if the response is an IAM account
 * @param response The response to check
 */
const isIamAccount = (response: any): response is IamAccount => {
  return 'name' in response;
};
